import * as React from 'react';

const EmployeeInline = ({ firstName, lastName, position, linkedInProfile }) => {
  return (
    <>{firstName['en-US']} {lastName['en-US']} ({position['en-US']})</>
  );
};

export default EmployeeInline;
